export const AppSettings = {
    apiHost: process.env.REACT_APP_API_HOST ?? "%STORM_API_HOST%",
    issuer: process.env.REACT_APP_OKTA_ISSUER ?? "%STORM_UI_OKTA_ISSUER%",
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID ?? "%STORM_UI_OKTA_CLIENT_ID%",
    oktaAdminGroup: process.env.REACT_APP_OKTA_ADMIN_GROUP ?? "%STORM_UI_OKTA_ADMIN_GROUP%",
    oktaOff: process.env.REACT_APP_OKTA_OFF === "true",
};
